import React from 'react'
import { shallow } from 'enzyme'

import APIConfirmationModal  from '../../modals/APIConfirmationModal'

describe('APIConfirmationModal', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      toggleModal: jest.fn(),
      onSubmitClick: jest.fn(),
    },
    wrapper = shallow(<APIConfirmationModal {...props} />)
    instance = wrapper.instance()
  })

  describe('#render', () => {
    describe('when Cancel button is clicked', () => {
      it('should call props toggleModal method', () => {
        const cancelBtn = wrapper.find('Button').at(0)
        cancelBtn.simulate('click')
        expect(props.toggleModal).toHaveBeenCalledTimes(1)
      })
    })

    describe('when Submit button is clicked', () => {
      it('should call props onSubmit method', () => {
        const cancelBtn = wrapper.find('Button').at(1)
        cancelBtn.simulate('click')
        expect(props.onSubmitClick).toHaveBeenCalledTimes(1)
      })
    })

  })

})